import { useMemo } from "react"

import { DateFilterOperator } from "../date-filter.types"

export type OperatorSelectItem = {
  label: string
  value: DateFilterOperator
  key: DateFilterOperator
}

export const useOperatorsSelectItems = (
  labelTranslationResolver: Record<DateFilterOperator, string>
): OperatorSelectItem[] => {
  return useMemo(() => {
    return Object.values(DateFilterOperator).map(
      (operator: DateFilterOperator): OperatorSelectItem => ({
        label: labelTranslationResolver[operator] ?? "",
        value: operator,
        key: operator,
      })
    )
  }, [labelTranslationResolver])
}
